import { useContext, useEffect, useState } from "react";
import { Col, Container, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import ComuneAutoSuggest from "../autocomplete/comune.autosuggest";
import UECard from "../UECard";
import ModalPopup from "../ModalPopup";
import { readCurrentState, sendCurrentState, StepContext } from "../StepContext";
import TipoIndAutoSuggest from "../autocomplete/tipo.autosuggest";
import IndirizzoAutoSuggest from "../autocomplete/indirizzo.autosuggest";

import img_mail from "../../img/sp-email.png";
import img_carta from "../../img/sp-carta.png";
import useQuery from "../../hooks/useQuery";
import { validateEmail } from "./Step1";

//https://github.com/moroshko/react-autosuggest#installation
//npm install react-autosuggest --save

var msgText = '';
var msgTitle = '';

var readURLParams = true;

function Step3() {
    let query = useQuery();

    const [modalShow, setModalShow] = useState(false);

    const [comune, setComune] = useState({});
    const [comuneDesc, setComuneDesc] = useState("");

    const [cap, setCAP] = useState("");

    const [eletopo, setEletopo] = useState("");
    const [elet_id, seEletID] = useState("");

    const [telet_id, setTeletID] = useState("");
    const [telet, setTelet] = useState("");

    const [numero, setNumero] = useState("");
    const [suffisso, setSuffisso] = useState("");

    const [mail, setMail] = useState("");
    const [mail2, setMail2] = useState("");
    const [tipoIn, settipoIn] = useState(-1);//0-Mail 2-Cartaceo

    const { step, setStep } = useContext(StepContext);


    useEffect(() => {


        //console.log("step: " + step);

        if (readURLParams || (step < 3)) {
            if (StepContext.contratto)
                if (StepContext.contratto.mail)
                    setMail(StepContext.contratto.mail);

            MostraDatiGet();
            readURLParams = false;
        } else {
            MostraDatiLocalStorage();
        }

    }, []);

    function MostraDatiGet() {
        //console.log("MostraDatiGet");
        //console.log("tipoIn get:" + query.get("tipoIn"));

        if (query.has("tipoIn")) {
            let ti = query.get("tipoIn");
            if (ti == 0) {
                settipoIn(0);
            } else if (ti == 2) {
                settipoIn(2);
            }
        }
    }

    function MostraDatiLocalStorage() {
        //    console.log("MostraDatiLocalStorage");

        settipoIn(readCurrentState("tipoIn"));

        //     console.debug("tipoIn: " + tipoIn);
        //     console.debug("tipoIn: " + readCurrentState("tipoIn"));
        if (readCurrentState("tipoIn") == 0) {
            setMail(readCurrentState("tp_mail"));
            setMail2(readCurrentState("tp_mail"));
        } else
            if (readCurrentState("tipoIn") == 2) {
                let comune_tmp = {
                    com_id: readCurrentState("ird_comune"),
                    com_des: readCurrentState("ird_descrizione_comune"),
                    com_cap: readCurrentState("ird_cap")
                }
                setComune(comune_tmp);
                setComuneDesc(comune_tmp.com_des);//Aggiunto 
                setCAP(readCurrentState("ird_cap"));
                setNumero(readCurrentState("ird_civico"));
                setSuffisso(readCurrentState("ird_suffifo"));
                setEletopo(readCurrentState("ird_via")); //Aggiunto 
                setTelet(readCurrentState("ird_toponimo")) //Aggiunto 
                setTeletID(readCurrentState("ird_id_toponimo")) //Aggiunto
            }

    }

    const mailClick = () => {
        settipoIn(0)
    }
    const postaClick = () => {
        settipoIn(2)
    }
    const activeOption = (f) => {
        let active = "ue btn btn-q btn-yellow active_f";
        let noactive = "ue btn btn-q btn-yellow";

        if ((f == 'e') && (tipoIn == 0)) {
            return active;
        } else if ((f == 'c') && (tipoIn == 2)) {
            return active;
        } else {
            return noactive;
        }
    }

    function disabilitaTastitipoIn(f) {
        if (query.has("tipoIn")) {
            if ((f == 0) && (tipoIn == 2)) {
                return true;
            } else
                if ((f == 2) && (tipoIn == 0)) {
                    return true;
                }
        }
    }

    function noteInvioCartaceo1() {
        if (tipoIn == 2)
            return (
                <>
                    <h2>Se scegli la spedizione <u>Cartacea rinunci al BONUS</u></h2>
                </>
            )
    }

    function ModuloPosta() {
        return <>
            <br />
            <p style={{ margin: "0 50px", textAlign: "center", fontSize: "small" }}>Ogni anno emettiamo 1.000.000 di fatture, utilizziamo 250 tonnellate di carta per stamparle e migliaia di litri di carburante per
                consegnarle. E’ il nostro lavoro e siamo orgogliosi di farlo per Te. Con il tuo contributo, però, la nostra impronta può essere più verde.
                <br /><b>Richiedi ora la spedizione della fattura in formato elettronico.</b> La riceverai sempre puntuale. Il pianeta ti ringrazierà con un
                ambiente migliore, Umbria Energy, con un <b>bonus di 50 kWh per la fornitura elettrica e 10 Smc per quella gas</b>, riconosciuto ogni
                anno in occasione della ricorrenza della Giornata della Terra, il 22 aprile.</p>
            <hr />
            <h3 style={{ margin: "0 auto", maxWidth: "800px", textAlign: "center" }}>Voglio richiedere l'invio dei documenti per posta</h3>
            <Container className="container-fluid">
                <Row className="justify-content-center" style={{ display: 'flex' }} >
                    <Col className="col-md-auto">
                        <label htmlFor="comune" >
                            Comune*<br />
                            <ComuneAutoSuggest id="comune" inputText={comuneDesc} onSelectValue={(s) => { setComune(s); setCAP(s.com_cap); }} />
                        </label>
                    </Col>
                    <Col className="col-md-auto">
                        <label htmlFor="cap">
                            CAP<br />
                            <input type="text" className="ue ue-text" id="cap" placeholder="CAP"
                                maxLength="5" value={cap} onChange={(e) => { setCAP(e.target.value) }} />
                        </label>
                    </Col>

                </Row>
                <Row className="justify-content-center" style={{ display: 'flex' }} >
                    <Col className="col-md-auto">
                        <label htmlFor="tipo" >
                            Tipo indirizzo* (Via, Piazza, Strada...)<br />
                            <TipoIndAutoSuggest inputText={telet} id="tipo" onSelectValue={(s) => { setTeletID(s.telet_id); setTelet(s.telet_des.toUpperCase()) }} onChange={(e) => { setTelet(e);setTeletID(""); setTelet("") }} />
                        </label>
                    </Col>
                    <Col className="col-md-auto">
                        <label htmlFor="via">
                            Indirizzo*<br />
                            <IndirizzoAutoSuggest inputText={eletopo} com_id={comune.com_id} id="via" onSelectValue={(s) => { seEletID(s.elet_id); setEletopo(s.indirizzo) }} onChange={(e) => { setEletopo(e) }} />
                        </label>
                    </Col>
                </Row>
                <Row className="justify-content-center" style={{ display: 'flex' }} >
                    <Col className="col-md-auto">
                        <label htmlFor="numero" >
                            Numero*<br />
                            <input type="text" className="ue ue-text" id="numero" placeholder="Numero Civico"
                                value={numero} onChange={(e) => { setNumero(e.target.value) }} />
                        </label>
                    </Col>
                    <Col className="col-md-auto">
                        <label htmlFor="suffisso">
                            Suffisso<br />
                            <input type="text" className="ue ue-text" id="suffisso" placeholder="Suffisso"
                                value={suffisso} onChange={(e) => { setSuffisso(e.target.value.toUpperCase().substring(0,5)) }} />
                        </label>
                    </Col>
                </Row>
            </Container>
        </>
    }

    function ModuloMail() {
        return <>
            <hr />
            <h2 style={{ color: "green" }}><b>GRAZIE!</b></h2>

            <h4 style={{ margin: "0 auto", maxWidth: "800px", textAlign: "center" }}>Oltre a rispettare l'ambiente, con la spedizione via E-MAIL riceverai la fattura più velocemente e sarai al sicuro da disguidi nel recapito postale</h4>

            <div >
             {/*    <Row className="justify-content-center" style={{ display: 'flex' }} >

                    <Col className="col-md-auto">
                        <label htmlFor="mail">
                            Indirizzo di recapito*<br />
                            <input type="email" className="ue ue-text" id="mail" placeholder="Inserisci la tua e-mail"
                                maxLength="200" value={mail} onChange={(e) => { setMail(e.target.value.toUpperCase().trim()) }} onPaste={(e) => { e.preventDefault(); }} onCopy={(e) => { e.preventDefault(); }} />
                        </label>
                    </Col>
                </Row>
                <Row className="justify-content-center" style={{ display: 'flex' }} >
                    <Col className="col-md-auto">
                        <label htmlFor="mail2">
                            Conferma Indirizzo E-Mail*<br />
                            <input type="mail" className="ue ue-text" id="mail2" placeholder="Conferma la tua e-mail"
                                maxLength="200" value={mail2} onChange={(e) => { setMail2(e.target.value.toUpperCase().trim()) }} onPaste={(e) => { e.preventDefault(); }} />
                        </label>
                    </Col>
                </Row>
                */}
            </div>
        </>
    }

    function VisualizzaModulo() {
        if (tipoIn == 2)
            return ModuloPosta()
        if (tipoIn == 0)
            return ModuloMail()
    }



    function Validation() {
        let conx = {};

        if (tipoIn == -1) {
            msgText = 'Seleziona la modalità con cui vuoi ricevere le fatture';
            msgTitle = 'Informazioni non valide o mancanti';
            setModalShow(true);
            return false;
        }

        if (tipoIn == 0) {
           /* if ((mail == '')) {
                msgText = "Inserisci l'indirizzo e-mail dove vuoi ricevere le fatture";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            if (!validateEmail(mail)) {
                msgText = "L'indirizzo e-mail indicato non è valido";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            if ((mail != mail2)) {
                msgText = "La mail di conferma non coincide con quella indicata";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            */
            conx = {
                step: step,
                tipoIn: tipoIn,
                tp_mail: StepContext.contratto.mail
            };

        } else if (tipoIn == 2) {
            if (comune.com_id == undefined) {
                msgText = "Inserisci le informazoni dell'indirizzo dove vuoi ricevere le fatture per posta, inserisci il comune e selezionalo dalla lista delle proposte.";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }

            if ((isNaN(cap)) || (cap.trim().length != 5)) {
                msgText = "Inserisci un CAP valido";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }

            if ((telet_id == undefined) || (telet_id == null) || (telet_id == "")) {
                msgText = "Inserisci un tipo di indirizzo selezionandolo dalla lista delle proposte. Ad esempio VIA, STRADA, PIAZZA....";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }

            if ((eletopo == undefined) || (eletopo == null) || (eletopo == "")) {
                msgText = "Inserisci un indirizzo valido.";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }

            if (isNaN(numero)) {
                msgText = "Inserisci un numero civico valido (solo parte numerica)";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }

            conx = {
                step: step,
                tipoIn: tipoIn,
                ird_nazione: 'ITALIA',
                ird_id_toponimo: telet_id,
                ird_toponimo: telet.toUpperCase().trim(),
                ird_via: eletopo.toUpperCase().trim(),
                ird_descrizione_comune: comune.com_des.toUpperCase().trim(),
                ird_comune: comune.com_id,
                ird_cap: cap,
                ird_civico: numero,
                ird_suffisso: suffisso.toUpperCase().trim().substring(0,5)
            };
        } else {

            //in caso di recapito via mail, l'indirizzo indicato sostituisce quello inserito nel primo step
            conx = {
                step: step,
                tipoIn: tipoIn,
                tp_mail: mail,
                mail: mail
            };
            return false;
        }






        StepContext.contratto = { ...StepContext.contratto, ...conx };


        sendCurrentState();

        return true;
    }

    return (
        <UECard BackButton={true} NextButton={true} className="S1Div" style={{ marginLeft: "250px", width: "100%", textAlign: "center", marginTop: "50px" }} onValidate={Validation}>
            <h2 style={{ color: "green" }}>Come vuoi ricevere le Fatture?</h2>
            {noteInvioCartaceo1()}
            <Row className="justify-content-center" style={{ display: 'flex' }} >
                <Col className="text-center text-md-right">
                    <OverlayTrigger overlay={disabilitaTastitipoIn(0) ? <Tooltip id="tooltip-disabled1">L'offerta selezionata non prevede la scelta della spedizione via E-Mail, se vuoi attivare la spedizione via E-Mail contatta il Servizio Clienti</Tooltip> : <Tooltip style={{ visibility: "hidden" }} />}>
                        <span className="d-inline-block">
                            <button id="f_e" className={activeOption("e")} onClick={mailClick} disabled={disabilitaTastitipoIn(0)}><span><img src={img_mail}></img></span><br />SPEDIZIONE EMAIL</button>
                        </span>
                    </OverlayTrigger>
                    <OverlayTrigger overlay={disabilitaTastitipoIn(2) ? <Tooltip id="tooltip-disabled1">L'offerta selezionata non prevede la scelta della spedizione via posta cartecea, se vuoi attivare la spedizione cartacea contatta il Servizio Clienti</Tooltip> : <Tooltip style={{ visibility: "hidden" }} />}>
                        <span className="d-inline-block">
                            <button id="f_g" className={activeOption("c")} onClick={postaClick} disabled={disabilitaTastitipoIn(2)}><span><img src={img_carta}></img></span><br />SPEDIZIONE CARTACEA</button>
                        </span>
                    </OverlayTrigger>
                </Col>
            </Row>
            <div style={{ paddingLeft: "15px" }}>
                {VisualizzaModulo()}
            </div>

            <ModalPopup title={msgTitle} message={msgText} show={modalShow} onHide={() => setModalShow(false)} />
        </UECard>

    );
}

export default Step3